/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityKeywordsResult } from './ControlEntityKeywordsResult';
import {
    ControlEntityKeywordsResultFromJSON,
    ControlEntityKeywordsResultFromJSONTyped,
    ControlEntityKeywordsResultToJSON,
} from './ControlEntityKeywordsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityKeywordsResponse
 */
export interface ControlPaginatedEntityKeywordsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityKeywordsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityKeywordsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityKeywordsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityKeywordsResult>}
     * @memberof ControlPaginatedEntityKeywordsResponse
     */
    results?: Array<ControlEntityKeywordsResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityKeywordsResponse interface.
 */
export function instanceOfControlPaginatedEntityKeywordsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityKeywordsResponseFromJSON(json: any): ControlPaginatedEntityKeywordsResponse {
    return ControlPaginatedEntityKeywordsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityKeywordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityKeywordsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityKeywordsResultFromJSON)),
    };
}

export function ControlPaginatedEntityKeywordsResponseToJSON(value?: ControlPaginatedEntityKeywordsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityKeywordsResultToJSON)),
    };
}

